let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kqhVG")).then(() => parcelRequire('i54xW'));